import React from "react";
import {BrowserRouter as Rounter, Switch, Route} from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import {history} from "./helpers/history";
import Forgot from "./components/Forgot";
import ChangePassword from "./components/ChangePassword";
import SmsSecurity from "./components/SmsSecurity";

function App() {

    if(window.location.pathname === "/" || window.location.pathname === "/authservice-ui" || window.location.pathname === "/authservice-ui/"){
        window.open("/authservice-ui/index.html", "_self");
    }

    return (
        <Rounter>
        <div className="external_area">
            <div className="login_card">
                <Route history={history}>
                <Switch>
                        <Route exact path="/authservice-ui/index.html" component={Login} />
                        <Route path='/authservice-ui/register/index.html' component={Register}></Route>
                        <Route path='/authservice-ui/register' component={Register}></Route>
                        <Route path='/authservice-ui/forgot/index.html' component={Forgot}></Route>
                        <Route path='/authservice-ui/forgot' component={Forgot}></Route>
                        <Route path='/authservice-ui/resetPassword/index.html' component={ChangePassword}></Route>
                        <Route path='/authservice-ui/sms/index.html' component={SmsSecurity}></Route>
                </Switch>
                </Route>
            </div>
            <div className="background"></div>
        </div>
        </Rounter>
    );
};

export default App;



